// Turks (tr), dailyApp: zelfde vorm als dailyApp.nl.ts (WP4 dagelijkse schermen).
export const appDailyTr = {
    stars: {
        tab: 'Yıldızlar',
        approvals: 'Onayla',
        approvalsEmpty: 'Onaylanacak bir şey yok.',
        handled: 'Tamamlananlar',
        rewards: 'Ödüller',
        savingFor: '{goal} için biriktiriyor',
        noGoal: 'Henüz birikim hedefi yok',
        goalLabel: '{name} için birikim hedefi',
        adjustLabel: '{name} için puanları ayarla',
        history: '{name} için son puanlar',
        info: 'Çocuklar görevlerle yıldız kazanır. Burada her çocuğun ne harcayabileceğini, ne için biriktirdiğini ve neyin hâlâ onay beklediğini görürsün. Ödül eklemek veya değiştirmek için Ödüller bölümüne git.',
    },
    agenda: {
        title: 'Takvim',
        rides: 'Ulaşım',
        tools: 'Takvim için daha fazlası',
        toolsTitle: 'Takvim',
        calendars: 'Takvimleri bağla',
        calendarsHint: 'Google, Outlook veya iCloud etkinliklerini burada göster.',
        exportHint: 'Tüm etkinlikler takvim dosyası olarak (.ics).',
        trashHint: 'Silinen etkinlikleri 30 gün içinde geri getir.',
    },
    pinboard: {
        title: 'Pano',
        label: 'Panonun bölümleri',
        notes: 'Notlar',
        messages: 'Mesajlar',
        wishes: 'Dilekler',
    },
    kids: {
        title: 'Çocuklar',
        label: 'Çocuklar için bölümler',
        learning: 'Öğrenme hedefleri',
        growth: 'Büyüme',
        school: 'Okul',
        filter: 'Bir çocuk seç',
        all: 'Tüm çocuklar',
    },
    chores: {
        label: 'Görev türü',
        series: 'Düzenli görevler',
        chores: 'Ev işleri',
    },
    recipes: {
        more: 'Daha fazla yükle',
        shown: '{shown} / {total}',
        pick: 'Listeden bir tarif seç.',
        filter: 'Hangi tarifler',
    },
    menu: {
        past: {
            one: 'Bu hafta {count} gün önce',
            other: 'Bu hafta {count} gün önce',
        },
        showPast: 'Göster',
        hidePast: 'Gizle',
        suggestions: 'Öneriler',
        suggestionsCount: 'Öneriler ({count})',
        shelfHint: 'Bir tarifi bir güne sürükle.',
    },
};
//# sourceMappingURL=dailyApp.tr.js.map